export const UNKNOWN_TIME = '??:??';
export const UNSPECIFIED_TIME = '--:--';
export const UNSPECIFIED = 'Unspecified';
export const UNKNOWN_TYPE = '????';
export const UNKNOWN_AMOUNT = '??.??';
export const UNKNOWN_LOCATION = '????????';
